"use strict";

define('components/filter_bar/table/leads_action',['components/ajax'], function(ajax) {

    var leadsActionComponent = {

        initWithContext: function(context) {
            var button = context.buttonbarNode.find('.selection-lead-action button');

            button.click(function() {
                var formData = new FormData();
                var objectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds();
                formData.append('object_ids', JSON.stringify(objectIds));
                formData.append('object_type', context.tableFilterBarData.tableObjectType);
                var url = $(this).data('url');
                ajax(url, {
                    formData: formData,
                    remote: url,
                    onFailure: function(result) {
                        var alert_message = $('#alert-message');
                        alert_message.html(result.alert.message);
                        alert_message.removeClass('hidden');
                        alert_message.addClass('alert-'+result.alert.status);
                        alert_message.addClass('alert-dismissible');
                        alert_message.prepend(
                            '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>'
                        );
                    }
                });
            });
        },
        onModal: function(handler) {
            $(document).on('jsq:modalSuccess', handler);
        }
    };

    return leadsActionComponent;
});

